import { useState, useEffect } from 'react'
import { useSearchParams } from "react-router";
import { getTransferencia } from "../../Fetch/GetComp";
import { useNavigate } from "react-router"
import { Link } from 'react-router'
import Navbar from "../../Components/NavBar/Navbar";
import Loading from "../../Components/Loading/Loading";
import Tabla, { Cell, Row, Head, Body } from "../../Components/Tabla/Tabla";

export default function Pago() {

  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [Comp, setComp] = useState({
    Pay: [],
    Cot: [], 
    Loading:false
  })

  useEffect(() => {
    document.title = 'Desgloce de Pagos';
    getTransferencia(searchParams.get("pay"), searchParams.get("hash")).then(res => {

      if (res.valid) {
        localStorage.setItem("ContaKMPCot", res.token);
        setComp(v => ({
          ...v,
          Loading:true,
          Pay: res.data.payload.Pay.map((pay) => ({
            ...v.Pay,
            idPay: pay.idMovimiento_Bancario,
            idPayhash: pay.IdMovhash,
            Fecha: pay.Fecha,
            Monto: pay.Monto,
            Nota: pay.Notas
          })),
          Cot: res.data.payload.Cot.map((cot) => ({
            ...v.Cot,
            idMov: cot.idMovimiento_Bancario_li,
            idCot: cot.idCotizacion,
            Cothash: cot.Cothash,
            Monto: cot.Monto,
            UUID: cot.UUID,
            Facthash: cot.UUIDhash,
            Nota: cot.Nota,
          }))
        }))
      } else {
        localStorage.removeItem("ContaKMPCot")
        navigate("/")
      }
    })
  }, [searchParams, navigate])

  return (
   
      <Navbar
        menu={[
          { txt: "Cotizaciones", link: "/FindCotizacion" },
          { txt: "Pagos", link: "/Pagos" }
        ]} >
          {
            Comp.Loading===true ?
          <>
      <Tabla className='PagosUser'>
        <Head>
          <Row className='Flags'>
            <Cell>Pago</Cell>
            <Cell>Fecha</Cell>
            <Cell>Monto</Cell>
            <Cell>Descripción</Cell>
          </Row>
          {
            Comp.Pay.map((Pa, iPa) =>
            (
              <Row key={iPa}>
                <Cell>PA-{Pa.idPay}</Cell>
                <Cell>{Pa.Fecha}</Cell>
                <Cell>
                  <Link to={`/PayView?hash=${Pa.idPayhash}&pay=${Pa.idPay}`} target="_blank" params={{ fromFeed: true }}>
                    $ {new Intl.NumberFormat('en-US').format(Pa.Monto)}
                  </Link>
                </Cell>
                <Cell>{Pa.Nota}</Cell>
              </Row>
            ))
          }
        </Head>
        <Body>
          <Row>
            <Cell></Cell>
          </Row>
        </Body>
      </Tabla>

      <Tabla className='PagosUser'>
        <Head>
          <Row className='Flags'>
            <Cell>Cotización</Cell>
            <Cell>Monto</Cell>
            <Cell>Descripción</Cell>
            <Cell>Factura</Cell>
          </Row>
        </Head>
        <Body>
          {
            Comp.Cot.map((Pa, iPa) =>
            (
              <Row key={iPa}>
                <Cell>
                  <Link to={`/PDFView?hash=${Pa.Cothash}&cot=${Pa.idCot}`} target="_blank" params={{ fromFeed: true }}>
                    KMP-{Pa.idCot}
                  </Link>
                </Cell>
                <Cell>$ {new Intl.NumberFormat('en-US').format(Pa.Monto)}</Cell>
                <Cell>{Pa.Nota}</Cell>
                <Cell>
                  <Link to={`/FactView?hash=${Pa.Facthash}&uuid=${Pa.UUID}`} target="_blank" params={{ fromFeed: true }}>{Pa.UUID}</Link>
                </Cell>
              </Row>
            ))
          }
        </Body>
      </Tabla>
      </>
      :
      <Loading style={{ top: '80px' }}/>
    }
    </Navbar>
  )
}